import React, { useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ArrowLeft, Loader2 } from 'lucide-react';
import Layout from '../../layouts/Layout';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import PropertyCard from '../../components/PropertyCard';
import { useFavorites } from '../../hooks/useFavorites';
import coeurIcon from '../../assets/img3d/coeur.png';

const FavoritesPage = () => {
  const navigate = useNavigate();
  const { favorites, loading, fetchFavorites } = useFavorites();

  useEffect(() => {
    fetchFavorites();
  }, [fetchFavorites]);

  const normalizedFavorites = useMemo(() => {
    if (!Array.isArray(favorites)) return [];
    return favorites
      .map((fav) => fav?.property || fav)
      .filter((property) => property && property.id);
  }, [favorites]);

  const hasFavorites = normalizedFavorites.length > 0;

  return (
    <Layout
      headerConfig={{
        icon: coeurIcon,
        iconColor: 'bg-white',
        title: 'Mes Coups de Cœur',
        subtitle: 'Toutes vos propriétés favorites en un seul endroit',
        primaryAction: 'Explorer les biens',
        secondaryAction: 'Retour',
        onPrimaryAction: () => navigate('/properties'),
        onSecondaryAction: () => navigate(-1),
      }}
    >
      <div className="space-y-6">
        {/* <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-rose-50 flex items-center justify-center">
                  <Heart className="h-5 w-5 text-rose-500" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Favoris</p>
                  <p className="text-xl font-semibold text-gray-900">
                    {hasFavorites ? `${normalizedFavorites.length} bien${normalizedFavorites.length > 1 ? 's' : ''}` : 'Aucun favori'}
                  </p>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => fetchFavorites()}
                disabled={loading}
              >
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Actualiser
              </Button>
            </div>
          </CardContent>
        </Card> */}

     
          <CardContent className="p-6">
            {loading ? (
              <div className="flex items-center justify-center py-16 text-gray-500">
                <Loader2 className="h-6 w-6 animate-spin mr-2" />
                Chargement de vos favoris...
              </div>
            ) : !hasFavorites ? (
              <div className="text-center py-16 text-gray-500">
                <Heart className="h-12 w-12 mx-auto mb-4 text-gray-300" />
                <p className="text-base font-medium mb-1">Aucun favori</p>
                <p className="text-sm text-gray-400">
                  Explorez les biens disponibles et ajoutez vos préférés à vos coups de cœur.
                </p>
                <div className="mt-6 flex items-center justify-center gap-3">
                  <Button variant="default" onClick={() => navigate('/properties')}>
                    Découvrir les biens
                  </Button>
                  <Button variant="outline" onClick={() => navigate('/client')}>
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Retour au tableau de bord
                  </Button>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg/grid-cols-3 gap-6">
                {normalizedFavorites.map((property) => (
                  <PropertyCard key={property.id} property={property} />
                ))}
              </div>
            )}
          </CardContent>
    
      </div>
    </Layout>
  );
};

export default FavoritesPage;

